import React from 'react';
import Button from 'components/shared/Button';
import Modal from 'components/shared/Modal';
import Input from 'components/form/Input';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { initiateForgotPassword } from 'state/features/auth/forgotPasswordSlice';
import Toast from 'components/shared/Toast';

const Index = () => {
  // There'll be a state to manage validity of the form
  const [isValid, setIsValid] = React.useState(true);
  const [toastIsOpen, setToastIsOpen] = React.useState(false);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [email, setEmail] = React.useState('');

  const { status, successMessage, errorMessage } = useAppSelector(
    (state) => state.forgotPassword
  );
  const dispatch = useAppDispatch();

  const handleClose = () => {
    setModalIsOpen(false);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // Handle Form Submit logic
    if (!email.trim()) {
      return;
    }
    dispatch(initiateForgotPassword({ email, userType: 'merchant' }));
  };

  React.useEffect(() => {
    setToastIsOpen(false);
  }, []);

  React.useEffect(() => {
    if (status === 'failed') {
      setToastIsOpen(true);
    }
    if (status === 'succeeded') {
      setModalIsOpen(true);
      setToastIsOpen(true);
      setEmail('');
    }
  }, [status]);

  return (
    <div className="my-32 flex w-full items-center justify-center">
      <div className="w-full max-w-[600px] space-y-2">
        <h2 className="p-8 text-3xl font-medium text-black">
          Please enter your email address to reset your password
        </h2>

        <form onSubmit={handleSubmit}>
          <Input
            label="Email Address"
            placeholder="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <div className="w-full px-8">
            <Button
              isDisabled={!isValid}
              className={`${
                !isValid && 'bg-primary-500/50'
              }  mt-5 w-full py-4 text-lg font-medium text-white`}
              type="submit"
            >
              SUBMIT
            </Button>
          </div>
        </form>
      </div>

      <Modal open={modalIsOpen} onClose={handleClose}>
        <div className="flex flex-col">
          <h3 className="text-2xl font-medium text-black">Forgot Password?</h3>

          <p className="pt-5 pb-10 text-black">
            A password reset link has been sent to your email address
          </p>

          {/* <a
            href="mailto:"
            className="w-full rounded-md bg-primary-500 px-6 py-4 text-center text-[16px] text-lg font-medium text-white"
          >
            Open Email App
          </a> */}
        </div>
      </Modal>

      <Toast
        {...{
          open: toastIsOpen,
          handleClose: () => setToastIsOpen(false),
          severity: status === 'succeeded' ? 'success' : 'error',
          message: status === 'succeeded' ? successMessage : errorMessage,
        }}
      />
    </div>
  );
};

export default Index;
